<div class="login-bg">
  <div class="login-strip">
    <div class="login-strip-ls">
      <img src="assets/images/bureau-veritas.png" alt="">
    </div>
    <div class="login-strip-rs">Work Safety Solution</div>
  </div>
  <div class="container-fluid p-0">

    <div class="row g-0 align-items-center pt-4">
      <div class="col-lg-8">
        <div class="auth-bg">
          <div class="d-flex min-vh-70 p-4 pb-2">
            <!-- <div class="bg-overlay">

            </div> -->
            <div class="content-section">

              <div class="row g-0">

                <div class="col-lg-9">
                  <div class="logo-container">
                    <div class="logo-left">
                      <div class="logo">
                        <!-- <span class="vois-name">_<span class="lp-n">VO<b>IS</b></span> | SHW</span> -->
                        <span class="vois-name"><img src="assets/images/VOIS_LOGO_white.png" alt="VOIS | SHW"> | SHW</span>
                      </div>
                    </div>
                    <div class="logo-right">
                    </div>
                  </div>
                  <div class="row g-0">
                    <div class="col-lg-12">
                      <p class="login-text mb-3">
                        Welcome to the
                        <strong>VOIS India SHW Portal</strong>, your integrated platform for managing workplace safety and compliance. This application is
                        designed to create a safer, healthier, and more productive work environment by offering a range
                        of robust tools and features.
                      </p>
                      <p class="login-text">
                        This portal ensures a safe and healthy work environment for all. With comprehensive modules
                        including
                        Permit to Work (PTW), Hazard Identification and Risk Assessment (HIRA), Action Tracker,
                        Inspections, Training
                        , and
                        Management Information System (MIS)
                        , it streamlines safety processes, promotes proactive risk management, and ensures compliance
                        with health and safety standards. Together, these modules empower employees and management to
                        collaborate on maintaining high safety standards, fostering a culture of safety and well-being
                        across all levels.
                      </p>
                    </div>
                  </div>

                </div>
                <div class="col-lg-6">
                  <!-- <img src="assets/images/login-bg-5.png" alt="azadi 75"> -->
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <router-outlet></router-outlet>
      </div>
    </div>

    <div class="footer">
      <span>Managed by Bureau Veritas
        <!-- &nbsp;|&nbsp; <a href="javascript:void(0)" [matMenuTriggerFor]="menu">Privacy Policy</a>
        <mat-menu #menu="matMenu" class="mat-menu-custom-footer">
          <button mat-menu-item (click)="openLink('https:
          <button mat-menu-item (click)="openLink('https:
        </mat-menu> -->
      </span>
    </div>
  </div>
</div>
